import { useState } from "react";
import { usePlayer } from "../context/PlayerContext";
import { useLiveStats } from "../context/LiveStats";
import { HeroNeon } from "../components/HeroNeon";
import { Marquee } from "../components/Marquee";
import { MixesSection } from "../components/MixesSection";
import { TopWeek } from "../components/TopWeek";
import { ToolsSection } from "../components/ToolsSection";
import { FxDeck } from "../components/FxDeck";
import { Footer } from "../components/Footer";

export default function Home() {
  const { playMix } = usePlayer();
  const { counts } = useLiveStats();
  const [all, setAll] = useState([]);

  return (
    <main data-testid="home-page">
      <HeroNeon stats={counts.totals} latest={all[0]} onPlayLatest={() => all[0] && playMix(all[0], all)} />
      <Marquee />
      <TopWeek />
      <MixesSection onLoaded={setAll} />
      <ToolsSection />
      <FxDeck />
      <Footer />
    </main>
  );
}
